import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  OnInit,
  signal
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { interval, tap } from 'rxjs';
import { ConstantsService } from '~core/services/constants.service';

@Component({
  selector: 'auth-layout',
  standalone: false,
  templateUrl: './auth-layout.component.html',
  styleUrl: './auth-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AuthLayoutComponent implements OnInit {
  private readonly _destroyRef = inject(DestroyRef);
  private readonly _constantsService = inject(ConstantsService);
  readonly isSandboxEnvironment =
    this._constantsService.environment.environmentVariant === 'sandbox';

  readonly currentSlideIndex = signal(0);
  readonly slides = [
    {
      title: 'Pilotage central de la conformité fiscale',
      description: `Surveillez l’activité des entreprises, contrôlez les factures certifiées et analysez la conformité du système de facturation électronique à l’échelle nationale.`
    }
  ];

  ngOnInit(): void {
    this._startAutoPlay();
  }

  goToSlide(index: number): void {
    this.currentSlideIndex.set(index);
  }

  private _startAutoPlay(): void {
    interval(8000)
      .pipe(
        takeUntilDestroyed(this._destroyRef),
        tap(() => {
          this.currentSlideIndex.update(
            index => (index + 1) % this.slides.length
          );
        })
      )
      .subscribe();
  }
}
